import type { ShellNavGroup } from "@/components/shell/AppShell";

/** Nav items that belong to an optional module, keyed by href. */
const MODULE_BY_HREF: Record<string, string> = {
  "/admin-dashboard/staff": "staff_portal",
  "/admin-dashboard/staff-directory": "staff_portal",
  "/admin-dashboard/registrations": "registrations",
  "/admin-dashboard/teams": "teams",
  "/admin-dashboard/master-teams": "teams",
  "/admin-dashboard/players": "players",
  "/admin-dashboard/circuits": "circuits",
  "/admin-dashboard/waivers": "waivers",
  "/admin-dashboard/hotel-partners": "hotels",
  "/admin-dashboard/hotels": "hotels",
  "/admin-dashboard/event-management": "event_ops",
  "/admin-dashboard/event-management/inventory": "event_ops",
  "/admin-dashboard/event-management/checklists": "event_ops",
  "/admin-dashboard/event-management/officials": "officials",
  "/admin-dashboard/tournaments": "brackets",
  "/admin-dashboard/advertising/assets": "advertising",
  "/admin-dashboard/advertising/performance": "advertising",
  "/admin-dashboard/communications": "communications",
  "/admin-dashboard/live-sheets": "check_in",
};

/** Drops nav items whose module is disabled for the organization. */
export function filterNavByModules(
  groups: ShellNavGroup[],
  isEnabled: (key: string) => boolean
): ShellNavGroup[] {
  return groups
    .map((g) => ({
      ...g,
      items: g.items.filter((i) => {
        const mod = MODULE_BY_HREF[i.href];
        return !mod || isEnabled(mod);
      }),
    }))
    .filter((g) => g.items.length > 0);
}
